import React from 'react';
import PropTypes from 'prop-types';
import { View } from '@dbk/ui-react-utils';
import { Checkbox } from '@dbk/ui-forms';
import Text, { Large } from '@dbk/ui-text';
import { createContainer } from '@dbk-legacy/muster/react';
import { PALETTE } from '../../../../../../src/constants';

const ReportCategorySelectAll = (props) => {
  const { i18n: { messages}, handleSelectAllClick, isSelectAllChecked, isSelectAllIndeterminate, showUnreadOnly, isShowUnreadOnlyChecked, handleShowUnreadOnlyClick } = props;
  return (
    <View className="checkboxRow" style={{ paddingLeft: 18 }} >
      <Checkbox
        title={messages['app.chedelivery.reports.selectAll']}
        className="checkboxClass"
        onChange={handleSelectAllClick}
        label={<Text numberOfLines={2} ellipsizeMode={'tail'} className="selectCheckBox" style= { isSelectAllChecked ? {color: PALETTE.primaryActive}  : {} }>{messages['app.chedelivery.reports.selectAll']}</Text>}
        checked={isSelectAllChecked}
        indeterminate={isSelectAllIndeterminate}

      />

      {/* {(showUnreadOnly) &&
        <Checkbox
          checked={isShowUnreadOnlyChecked}
          className="checkboxClass"
          onClick={handleShowUnreadOnlyClick}
          label={<Large numberOfLines={2} ellipsizeMode={'tail'} className="selectCheckBox" style= { isShowUnreadOnlyChecked ? {color: PALETTE.primaryActive}  : { color:"#a7a8aa"}}>{messages['app.chedelivery.reports.showUnread']}</Large>}
        />
      } */}
    </View>

  );
}

ReportCategorySelectAll.propTypes = {
  i18n: PropTypes.shape({
    messages: PropTypes.object,
    handleSelectAllClick: PropTypes.function,
    isSelectAllChecked: PropTypes.function,
    isSelectAllIndeterminate: PropTypes.function,
    showUnreadOnly: PropTypes.bool,
    isShowUnreadOnlyChecked: PropTypes.function,
    handleShowUnreadOnlyClick: PropTypes.function
  }),
};

ReportCategorySelectAll.defaultProps = {
  i18n: {},
  handleSelectAllClick: '',
  isSelectAllChecked: '',
  isSelectAllIndeterminate: '',
  showUnreadOnly: '',
  isShowUnreadOnlyChecked: '',
  handleShowUnreadOnlyClick: ''
};

export default createContainer(
  {
    $queries: {
      i18n: {
        messages: true,
      },
    },
  },

)(ReportCategorySelectAll);
